export const datapoints = {
    FPFolderSelectorOpened: {
        name: 'FPFolderSelectorOpened',
    },
};
